<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-autocomplete v-if="params.searchType == 5" placeholder="请输入内容" :trigger-on-focus="false" v-model="params.searchValue" class="input-with-select" size="small" :fetch-suggestions="queryCity">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="巡演ID" :value="3"></el-option>
                            <el-option label="主题ID" :value="4"></el-option>
                            <el-option label="城市" :value="5"></el-option>
							<el-option label="审核人姓名" :value="6"></el-option>
                        </el-select>
                    </el-autocomplete>
                    <el-input v-else placeholder="请输入内容" v-model="params.searchValue" class="input-with-select" size="small" >
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
                            <el-option label="演出ID" :value="1"></el-option>
                            <el-option label="演出名称" :value="2"></el-option>
                            <el-option label="巡演ID" :value="3"></el-option>
                            <el-option label="主题ID" :value="4"></el-option>
                            <el-option label="城市" :value="5"></el-option>
                            <el-option label="发起人ID" :value="7"></el-option>
                            <el-option label="发起人名称" :value="8"></el-option>
							<el-option label="审核人姓名" :value="6"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">                    
                    <el-select v-model="params.auditStatus" placeholder="请选择" size="small">                        
                        <el-option label="仅看待审核的" :value="-1"></el-option>
                        <el-option label="仅看已通过的" :value="1"></el-option>
                        <el-option label="仅看已拒绝的" :value="0"></el-option>   
                        <el-option label="不限制审核状态" value=""></el-option>                     
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
				    <el-select v-model="params.activityChannel" placeholder="不限制演出来源" class="fl fl-big-select" clearable size="small">
				    	<el-option label="不限制演出来源" value=""></el-option>
				        <el-option v-for="(item, index) in activityChannel" :label="item.value" :key="index" :value="item.key"></el-option>
				    </el-select>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">                    
                    <el-select v-model="params.siteTagTypeId" placeholder="请选择" size="small">
                        <el-option label="不限制场地类型" value=""></el-option>
                        <el-option v-for="(item, index) in siteTypeTagList" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">                    
                    <el-select v-model="params.showType" placeholder="请选择" size="small">
                        <el-option label="优先展示最早提交审核的" :value="1"></el-option>
                        <el-option label="优先展示最晚提交审核的" :value="2"></el-option>
                        <el-option label="优先展示最新开演的" :value="3"></el-option>
                        <el-option label="优先展示最新审核的" :value="4"></el-option>                       
                    </el-select>
                </el-col>
				<el-col :xs="24" :sm="12" :md="14" :lg="12" :xl="8">
				    <div class="clearfix timeType">
				        <el-input class="input-with-select fl" size="small">
				            <el-select v-model="timeType" slot="prepend" placeholder="请选择">
				                <el-option label="最近审核时间" :value="1"></el-option>
				            </el-select>
				        </el-input>
				        <el-date-picker
				            v-model="datetimerange"
				            type="datetimerange"
				            start-placeholder="开始时间"
				            end-placeholder="结束时间"
				            class="fl"
				            size="small"
				            value-format="yyyy-MM-dd HH:mm:ss"
				            :default-time="['00:00:00', '23:59:59']"
				            align="right"
				            unlink-panels
				            >
				        </el-date-picker>
				    </div>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button v-if="$utils.have('/activity/onlineAudit/list')"  type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button v-if="$utils.have('/activity/onlineAudit/list')" type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
				
                <el-table-column label="审核状态">
                    <template slot-scope="scope">                        
						{{scope.row.operation ==1 ? '审核通过' : scope.row.operation ==0 ? '已拒绝' : '待审核'}}
                    </template>
                </el-table-column>
				<el-table-column prop="activityChannel" label="内容渠道"></el-table-column>
                <el-table-column prop="siteTypeTagName" label="场地类型"></el-table-column>
                <el-table-column label="城市" prop="cityName"></el-table-column> 
                <el-table-column label="ID" prop="id"></el-table-column>                 
                <el-table-column label="名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <el-link class="ellipsis title" @click="$refs.H5Preview.show('/pages/activity/detail/detail?activityId='+scope.row.id)">
                            {{ scope.row.titleStr || scope.row.title }}
                        </el-link>
                    </template>
                </el-table-column>
                <el-table-column label="首次开演时间" prop="beginShowTime" min-width="150"></el-table-column> 
                <el-table-column label="发起人" prop="initiator" show-overflow-tooltip></el-table-column> 
                <el-table-column label="提交审核时间" prop="submitAuditTime" min-width="150"></el-table-column>  
                <el-table-column label="审核人" prop="auditorName"></el-table-column>  
                <el-table-column label="审核时间" prop="auditorTime" min-width="150"></el-table-column>
                <el-table-column fixed="right" label="操作" width="230" >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/activity/onlineAudit/audit') && scope.row.operation == -1"
                            icon="el-icon-s-check"
                            @click="toVerify(scope.row.recordId)"
                            >审核</el-button>
                        <el-button
                            type="text"
                            size="small"
                            v-if="$utils.have('/activity/onlineAudit/auditInfo')"
                            icon="el-icon-edit"
                            @click="toDetail(scope.row.id)"
                            >管理</el-button>
                        <el-button
                            type="text"
                            size="small"
                            icon="el-icon-share"
                            @click="$refs.WapLink.show(scope.row)"
                            >演出预览</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0"
            >
            </el-pagination>
        </div>
        <GoodsView ref="goodsView"></GoodsView>
        <H5Preview ref="H5Preview"></H5Preview>
		<wap-link ref="WapLink"></wap-link>
    </div>
</template>
<script>
import GoodsView from '@/components/CodeView';
import H5Preview from '@/components/H5Preview';
import {fuzzyQueryCity} from '@/assets/js/commonApi';
import WapLink from "./components/wap-link.vue";
const defaultParams = {
    pageNo: 1,
    searchType: 1,
    searchValue: '',
    auditStatus:-1,
    // activityType: 0,
    showType: 1,
    siteTagTypeId: '',
	activityChannel:''
}
export default {
    components:{GoodsView,H5Preview,WapLink},
    data() {
        return {
            data: null,
            dataList: null,
            params: { 
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                searchType: parseInt(this.$route.query.searchType || 1),
                searchValue: this.$route.query.searchValue || '',
                auditStatus: parseInt(this.$route.query.auditStatus || -1),
                // activityType: parseInt(this.$route.query.activityType || 0),
                showType: parseInt(this.$route.query.showType || 1),
                siteTagTypeId: parseInt(this.$route.query.siteTagTypeId) || "",
            },
            listLoading: true,
            sswap:process.env.VUE_APP_SSWAP_URL,
            queryLoading: false,
            siteTypeTagList: [],
			timeType:1,
			datetimerange:[this.$route.query.startTime || '' , this.$route.query.endTime || ''],
			activityChannel:[]
        };
    },
    created(){
        this.getSiteTypeTag();
		this.getChannel()
    },
    mounted() {
        this.getDataList();
    },    
    methods: {
        //获取场地类型
        getSiteTypeTag(){
            this.$request({
                url: "/styleTag/showType/site/all",
                method: "post",
                params: {isAll: 1}
            }).then(res => {
                const { state, result } = res.data;
                if(state == 1){
                    this.siteTypeTagList = result || []
                }
            }) 
        },
        //获取列表
        getDataList() {
            this.listLoading = true;
			this.params.startTime = this.datetimerange && this.datetimerange[0] || '',
            this.params.endTime = this.datetimerange && this.datetimerange[1] || ''
            const data = {...this.params};
            if(!data.activityType) delete data.activityType;
            if(!data.status) delete data.status;
            this.$request({
                url: '/activity/onlineAudit/list',
                method: 'POST',
                data,
            })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if (state == 1 && result) {
                        this.data = result;
                        const data = result.result || [];
                        if(data.length){
                            data.forEach(item=> {
                                if(item.title && item.title.length>40){
                                    item.titleStr = item.title.slice(0,40) + '...'
                                }
                            })
                        }
                        this.dataList = data;
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .finally(() => {
                    this.listLoading = false;
                });
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
		//获取演出渠道
		getChannel() {
			this.$request({
				url: "/common/activitySource",
				method: "post",
				
			}).then(res => {
				const { state, result } = res.data;
				if (state == 1) {
					this.activityChannel = result || []
				}
			})
		},
        //重置搜索
        reset() {
			this.datetimerange = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
				activityChannel:''
            }
            this.getDataList();
        },
        toDetail(activityId){
            // this.$router.push({path: `/activityManage/activity/edit/baseInfo/${activityId}`})
            // this.$router.push({
            //     path: `/activityManage/activity/edit/baseInfo/${activityId}`, 
            //     query: {
            //         redirect: this.$utils.objArgs(
            //             this.$router.currentRoute.path,
            //             this.params
            //         ),
            //     },
            // });
            window.open(`/activityManage/activity/edit/baseInfo/${activityId}?redirect=${this.$utils.objArgs(this.$router.currentRoute.path,this.params)}`);
        },
        toVerify(id){
            // this.$router.push({path: `/activityManage/onlineVerify/verify/${id}`})
            this.$router.push({
                path: `/activityManage/onlineVerify/verify/${id}`, 
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        //预览
        view(item){
            this.$refs.goodsView.show({
                ...item,
                title: item.titleStr || item.title,
                qrCodeUrl: this.sswap+'/pages/activity/detail/detail?activityId='+item.id
            })
        },

        //搜索城市
        async queryCity(query, cb){
            if (query === '' || this.params.searchType != 5) return;
            this.queryLoading = true;
            const response = await fuzzyQueryCity(query);
            const {msg, state, result} = response.data;
            this.queryLoading = false;
            if (state != 1) return this.$message.error(msg);
            // if (result && result.length > 0) {
                const cityList = result && result.map(city => {
                    return {
                        value: city.name,
                        // value: city.code
                    };
                }) || [];
                cb(cityList)
            // }
        }
    }
};
</script>
